class FormDataFormatter {

    /**
     * @param {object} object with data
     * @returns {FormData}
     */
    static getFormData(object) {
        let formData = new FormData();
        for(let key in object) {

            if(object[key] instanceof Array) {
                // not empty array
                if(object[key].length) {
                    object[key].map(function (item, index) {
                        if(item instanceof Blob) {
                            formData.append(key+'['+index+']', item, item.filename)
                        }
                        else {
                            formData.append(key+'['+index+']', item);
                        }

                    });
                }
                else {
                    // empty array
                    formData.append(key+'[0]', '')
                }

            }
            else {
                let value = object[key];
                if(typeof(value) === 'boolean') {
                    value = +value;
                }

                if(value === null || value === undefined) {
                    value = '';
                }

                formData.append(key, value);
            }
        }

        return formData
    }
}

export default FormDataFormatter;


// WEBPACK FOOTER //
// ./web/src/services/FormDataFormatter.js